@if (showColumnSelectAccordion && (columns?.length ?? 0) > 0) {
  <app-customize-table-columns
    [columns]="columns"
    [disabled]="loading"
    (changeEvent)="columnSelectionChanged.emit($event)"
    [downloadSelected]="selectableRows"
    (downloadEvent)="downloadEvent.emit($event)"
    [disableDownload]="showFilterAccordion || disableDownload || rowsLength === 0"
    [isDynamic]="dynamicPagination"
  ></app-customize-table-columns>
}

@if (showFilterAccordion && (columns?.length ?? 0) > 0) {
  <app-table-search
    [isDynamic]="dynamicPagination"
    [lowerCaseInput]="lowerCaseInput"
    [disabled]="loading"
    [columns]="columns"
    [filterItems]="filterItems"
    [tableName]="tableName"
    [downloadSelected]="selectableRows"
    [disableDownload]="disableDownload || rowsLength === 0"
    (changeEvent)="filtersChanged.emit($event)"
    (downloadEvent)="downloadEvent.emit($event)"
    [enableExactMatch]="true"
    [middleActions]="middleActions"
  ></app-table-search>
}
